import { render, staticRenderFns } from "./TravelRoutePublish.vue?vue&type=template&id=04a01b26&scoped=true"
import script from "./TravelRoutePublish.vue?vue&type=script&lang=js"
export * from "./TravelRoutePublish.vue?vue&type=script&lang=js"
import style0 from "./TravelRoutePublish.vue?vue&type=style&index=0&id=04a01b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a01b26",
  null
  
)

export default component.exports